import styled from 'styled-components';

// CONSTANTS
import { WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.section`
  background-color: ${WHITE};
  padding-top: 112px;
  padding-bottom: 60px;
  text-align: center;

  .MuiGrid-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;

    ${breakpoints.down('sm')} {
      gap: 80px;
    }
  }

  .streaming-marketplace {
    &__content {
      position: relative;
      border-radius: 16px;
      border: 2px solid #024b45;
      padding: 115px 30px 37px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      ${breakpoints.down('xs')} {
        padding-top: 60px;
        margin-bottom: 20px;
      }
    }

    &__img {
      position: absolute;
      top: -65px;
      left: 0;
      width: 100%;

      img {
        max-width: 100%;
      }

      &--roku {
        top: -70px;

        img {
          max-width: 280px;
        }
      }
    }

    &__btn {
      min-width: 235px;
      margin-top: auto;
    }
  }
`;

export default Container;
